import React, { useEffect } from "react"
import { view } from "@risingstack/react-easy-state"
import { useParams } from "react-router-dom"
import ContentLoading from "components/common/ContentLoading"

import ImportsService from "services/users/imports.service"

const ImportDownloadRedirector = () => {
  const { importId } = useParams()

  useEffect(() => {
    const fetchDataAndRedirect = async () => {
      const tempState = {}

      await ImportsService.download({ pageState: tempState, importId })

      const { redirect_url } = tempState

      // TODO: Handle errors. Show error messages on the same page
      if (redirect_url) window.location = redirect_url
    }
    fetchDataAndRedirect()
  }, [importId])

  return <ContentLoading />
}

export default view(ImportDownloadRedirector)
